module.exports = __webpack_public_path__ + "static/media/origami2.f150bb4b.jpg";